export default __webpack_public_path__ + "static/media/first_steps_logo.ce5cb7f6.png";